import React from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

const PanelSize = (props) => {

    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-3 text-right content-item-heading">
                        <FormattedMessage id="app.pcb-quotation.pcb-panel-size"
                                          defaultMessage="Panel Size"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        <Link id="panelSize-qLink" to="/help/sizeHelp"
                              className="glyphicon glyphicon-question-sign question-link"></Link>
                    </div>
                    {props.pcbParam.edgeRails===1 ?
                    <PanelWithEdgeRails pcbParam={props.pcbParam}/> :
                    <PanelWithoutEdgeRails pcbParam={props.pcbParam}/>}
                </div>
            </div>
        </div>
    )
};

const PanelWithEdgeRails = (props) => {

    let panelByJLCPCBX = props.pcbParam.panelByJLCPCB_X;
    let panelByJLCPCBY = props.pcbParam.panelByJLCPCB_Y;

    const edgeRailValue = 20;

    if (panelByJLCPCBX === 0){
        panelByJLCPCBX = 1;
    }
    if( panelByJLCPCBY ===0){
        panelByJLCPCBY = 1;
    }

    let equationCalX ;
    let equationCalY ;

    if (props.pcbParam.edgeRails === 1) {
        localStorage.setItem("edgeRails", "y");
    }

    if((props.pcbParam.width * panelByJLCPCBX) > (props.pcbParam.length * panelByJLCPCBY) || (props.pcbParam.width * panelByJLCPCBX) === (props.pcbParam.length * panelByJLCPCBY)) {
        equationCalY = "+"+edgeRailValue+") = "+Math.round((panelByJLCPCBY*props.pcbParam.length+edgeRailValue)*100)/100;
        equationCalX = ") = "+Math.round((panelByJLCPCBX*props.pcbParam.width)*100)/100;
    } else {
        equationCalX = "+"+edgeRailValue+") = "+Math.round((panelByJLCPCBX*props.pcbParam.width+edgeRailValue)*100)/100;
        equationCalY = ") = "+Math.round((panelByJLCPCBY*props.pcbParam.length)*100)/100;
    }


    return(
       // {props.pcbParam.edgeRails==0 }
        <div className="btn-group col-md-9 pcb-details-div-items-panel-size">
            <div className="col-md-6 no-padding pcb-details-div-items">
                X : {"("+  props.pcbParam.width+ "x"+panelByJLCPCBX}{equationCalX}mm</div>
            <div className="col-md-6 no-padding pcb-details-div-items">
                Y : {"("+ props.pcbParam.length+"x"+panelByJLCPCBY}{equationCalY}mm</div>
            {/*<div className="col-md-4">&nbsp;</div>*/}
        </div>
    );
};

const PanelWithoutEdgeRails = (props) => {

    let panelXValue = props.pcbParam.panelByJLCPCB_X;
    let panelYValue = props.pcbParam.panelByJLCPCB_Y;

    if (panelXValue === 0 ){
        panelXValue =1;
    }
    if(panelYValue===0){
        panelYValue =1;
    }

    return(
        // {props.pcbParam.edgeRails==1 }
        <div className="btn-group col-md-9 pcb-details-div-items-panel-size">

            <div className="col-md-6 no-padding pcb-details-div-items">
                X : {"("+props.pcbParam.width+ "x"+panelXValue+") = "+Math.round((panelXValue*props.pcbParam.width)*100)/100}mm</div>
            <div className="col-md-6 no-padding pcb-details-div-items">
                Y : {"("+props.pcbParam.length+"x"+panelYValue+") = "+Math.round((panelYValue*props.pcbParam.length)*100)/100}mm</div>
            {/*<div className="col-md-4">&nbsp;</div>*/}
        </div>
    );
};

export default PanelSize;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/PanelSize.js